<template>
	<el-footer>
푸터얌
	</el-footer>
</template>

<script>
export default {
	name: "footerComp"
}
</script>

<style scoped>

</style>
